module.exports = __webpack_public_path__ + "img/canbadge-round-44mm-asa.ffdc394f.png";